import {
	EnhancedDropDownRHFWithLabel,
	EnhancedIOSSwitchRHF,
	EnhancedIOSSwitchRHFWithLabel,
	EnhancedMultiDropDownRHFWithLabel,
	EnhancedTextAreaFieldRHF,
	LabelPosition,
	RHookFormDatePicker,
	RHookFormTextFieldWithLabel,
} from "@websential/cosmic-v20";
import { FC, useEffect, useState } from "react";

import { Box } from "@mui/material";
import { CountryService } from "../../../services/common/CountryService";
import { useNavigateToLogout } from "../../../common/Common";

interface IPayrollQPIPEarningsSetupFieldsPanel {
	countryList: any;
	earningsList: any;
	provinceDDLItems: (value: any) => void;
}

export const PayrollQPIPEarningsSetupFieldsPanel: FC<
	IPayrollQPIPEarningsSetupFieldsPanel
> = ({ countryList, provinceDDLItems, earningsList }) => {
	const [provinceDDL, setprovinceDDL] = useState([]);
		const navigateToLogout = useNavigateToLogout();
	
		useEffect(() => {
			if (countryList && Array.isArray(countryList)) {
				const canada = countryList.find(
					(item: any) => item.label === "Canada" || "canada"
				);
				if (canada) {
					(async () => {
						try {
							const response = await CountryService.getProvinceOrStateDDL(
								navigateToLogout,
								canada.value,
								"Province"
							);
							setprovinceDDL(response);
							provinceDDLItems(response);
						} catch (err) {
							console.error("error", err);
						}
					})();
				}
			}
		}, [countryList]);
	return (
		<Box
			// sx={{
			// 	padding: "0",
			// 	"& .MuiTextField-root": { marginTop: 0, marginBottom: "12px" },
			// }}
		>
			<EnhancedDropDownRHFWithLabel
							label="Earning"
							selectName="earningId"
							testId={`earningId`}
							labelPosition={LabelPosition.Top}
							items={earningsList ?? []}
						/>
			<RHookFormTextFieldWithLabel
				id={"province"}
				testId={"province"}
				label={"Province"}
				readOnly={true}
				value={'Quebec'}
				defaultValue={'Quebec'}
			/>
			<EnhancedIOSSwitchRHFWithLabel
				name="enable"
				checked={false}
				testId="switch"
				// onSelectionChangeHandler={() => alert('clicked')} 
				label={"Enable"}			
				/>
			<RHookFormDatePicker
                name="effectiveDate"
                testId="123"
                label="Effective Date"
                labelPosition={LabelPosition.Top}
            />
			<RHookFormDatePicker
                name="endDate"
                testId="123"
                label="End Date"
                labelPosition={LabelPosition.Top}
            />
			
		</Box>
	);
};
